import { Controller } from '@hotwired/stimulus'

// Debounces an input's changes and resubmits its closest form. Used for
// live-search filters that should refresh a turbo-frame as the user types.
//
// Usage:
//   <%= form_tag(path, data: { controller: 'auto-submit' }) do %>
//     <%= text_field_tag :title, params[:title], data: { action: 'input->auto-submit#submit' } %>
//   <% end %>
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }
}
